import { LoaderFunctionArgs } from 'react-router-dom'
import { isAppStateReady } from 'src/state/store'
import { logger } from '$utils'
import useStockStore from '../../store'
import { defer } from 'react-router-dom'

export default async function loader(loaderFunctionArgs: LoaderFunctionArgs) {
  logger.debug(
    '[loader] About to await AppState being ready in EditInvoice loader'
  )
  await isAppStateReady()
  logger.debug('[loader] AppState should now be ready in EditInvoice loader')

  useStockStore.getState().resetInvoiceSlice()

  const invoiceDataPromise = useStockStore
    .getState()
    .initializeInvoiceData(loaderFunctionArgs)

  // Return a deferred promise to enable React Router's built-in loading state
  // This approach is currently required for compatibility with our PageLoadingSupport.tsx logic,
  // even though defer() is considered legacy in newer React Router versions.
  return defer({
    data: invoiceDataPromise
      .then(() => true)
      .catch((error) => {
        logger.error('[loader] EditInvoice loader error:', error)
        return false
      }),
  })
}
